import { observable, action, runInAction } from 'mobx';
import { RootStore, PagedList } from '..';
import { fetchWrapper } from '../../common/Fetch';
import { NotificationLevel } from '../NotificationStore';
import { SuccessableResult, KeyValue } from '../../common/BaseClasses';


export class Customer {
    id?: string = undefined;
    name = "";
    fullName = "";
    firstName = "";
    middleName = "";
    lastName = "";
    address = "";
    createDate?: Date = undefined;
    email = "";
    phone = "";
    comment = "";
    sourceName = "";
    toSiteBinded = false;
    friendlyName = "";
    managerName = "";
    managerPhone = "";
}

export class SearchedCustomer extends Customer {
    markedFields: any = {};
}

export class CustomersStore {

    _rootStore: RootStore;

    @observable customers: Customer[] = [];

    constructor(rootStore: RootStore) {
        this._rootStore = rootStore;
    }

    @action
    loadCustomers(page: number) {
        fetchWrapper('api/Customers/' + page, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<PagedList<Customer>>)
            .then(result => {
                runInAction("fetch complete loadCustomers", () => {
                    this.customers = result.items;
                });
            })
            .catch(res => {
                console.log(res);
            });
    }

    @action
    loadCustomer(id: string, callback: (customer: Customer) => void) {
        fetchWrapper('api/Customers/GetCustomer/' + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<Customer>)
            .then(result => callback(result))
            .catch(res => {
                console.log(res);
            });
    }

    @action
    searchCustomers(source: string, searchString: string, callback: (customers: SearchedCustomer[]) => void) {
        fetchWrapper(`api/Customers/search/${source}?searchString=` + searchString, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SearchedCustomer[]>)
            .then(result => callback(result))
            .catch(res => {
                console.log(res);
            });

    }

    @action
    saveCustomer(customer: Customer, source: string, callback: (customer: Customer) => void) {
        fetchWrapper(`api/customers`, {
            method: 'POST',
            body: JSON.stringify(Object.assign({}, customer, { sourceName: source })),
            headers: {
                'Content-Type': 'application/json'
            }
        }, this._rootStore.commonStore)
            .then(res => res.json() as Promise<SuccessableResult<Customer>>)
            .then(result => {
                if (result.isSuccess) {
                    callback(result.data);
                    this._rootStore.notificationStore.addNotification("Контрагент сохранен успешно!", NotificationLevel.success)
                }
                else {
                    this._rootStore.notificationStore.addNotification("Ошибка при создании контрагента! " + result.errorMessage, NotificationLevel.error)

                }
            })
            .catch(res => {
                console.log(res);
            });
    }


} 